import { render, staticRenderFns } from "./Nowebcam.vue?vue&type=template&id=084e5da4&"
import script from "./Nowebcam.vue?vue&type=script&lang=js&"
export * from "./Nowebcam.vue?vue&type=script&lang=js&"
import style0 from "./Nowebcam.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Nowebcam.vue"
export default component.exports